import { httpGet } from "@/services/api.service";
import lodashCloneDeep from "lodash/cloneDeep";
import { ENDPOINT_EMBASSY_COUNTRIES_CONFIG } from "@/common/constants/api";

export { _getEmbassyCountriesConfig as getEmbassyCountriesConfig };

let embassyCountriesConfig = null;

const _getEmbassyCountriesConfig = async () => {
  if (!embassyCountriesConfig) {
    try {
      const url = ENDPOINT_EMBASSY_COUNTRIES_CONFIG;
      const result = await httpGet({ url });
      const { data } = JSON.parse(result);
      if (data) {
        const embassyCitiesList = data.map((country) => {
          return {
            value: country.key,
            text: country.label,
          };
        });
        embassyCountriesConfig = embassyCitiesList;
        return embassyCitiesList;
      } else {
        return null;
      }
    } catch (error) {
      console.error(
        "Issue getting embassy countries config in embassy.service.js:",
        error
      );
      return null;
    }
  }
  return lodashCloneDeep(embassyCountriesConfig);
};
